import React from "react"

const IndexPage = () => (
  <>
    <h1>My Travel Blog</h1>
    <p>This is a demo site for <a href="https://erraticgenerator.com/blog/gatsby-blog-with-mapbox-gl-js-using-react-hooks">my blog post</a>.</p>
    <p>You can also check the <a href="https://github.com/erraticgenerator/gatsby-mapbox-blog">Github repo</a> (made with Gatsbyjs + Mapbox GL JS</p>
  </>
)

export default IndexPage
